import {TabList as UITabList, type TabListProps} from "@headlessui/react";
import clsx from "clsx";

export const TabList: React.FC<TabListProps> = ({children, className, ...rest}) => {
  return (
    <UITabList
      className={clsx("flex flex-row gap-2 overflow-x-scroll no-scrollbar", className)}
      {...rest}
    >
      {children}
    </UITabList>
  );
};
